<div class="container">
    <div class="row p-0 m-0 g-3">
        <div class="col-lg-4 col-xl-4 col-12">
            <label><b>System ID</b></label>
            <input type="text" class="form-control" readonly [value]="modelItem?.System_id">
        </div>
    </div>
    <div class="row p-0 m-0 g-3">
        <div class="col-md-4 col-12"> <button class="btn btn-cancel lg icon-start me-3 w-100" (click)="back()">
                <span class="material-symbols-outlined">
                    arrow_back
                </span>
                BACK
            </button></div>
        <div class="col-md-4 col-12"> <button class="btn btn-primary lg icon-start w-100" (click)="addPlan()">
                <span class="material-symbols-outlined">
                    add
                </span>
                Create Plan
            </button>
        </div>
        <div class="col-md-4 col-12 pt-2 text-end">
            <div class="flex">
                <span class="me-3"><b>Status System :</b></span>
                <button class="btn me-2"
                    [ngClass]="{'btn-primary':modelItem?.System_status == 1,'btn-cancel':modelItem?.System_status == 0}"
                    (click)="changeStatusSystem(1)"><b>ON</b></button>
                <button class="btn "
                    [ngClass]="{'btn-primary':modelItem?.System_status == 0,'btn-cancel':modelItem?.System_status == 1}"
                    (click)="changeStatusSystem(0)"><b>OFF</b></button>
            </div>
        </div>

    </div>
    <div class="row g-3 p-0 m-0">
        <div class="col-xl-4 col-lg-4 col-12 text-center m-action">
            <app-upload-file (FileUpload)="UploadFile($event)" [width]="1024" [height]="1024">
                <div class="box-item p-3">
                    <span class="material-symbols-outlined edit">
                        edit_square
                    </span>
                    <div class="box-image text-center ">
                        <img [src]="modelItem?.System_logo">
                    </div>
                    <p><b>{{modelItem?.System_name}}</b></p>
                    <span>1024 x 1024 </span>
                </div>
            </app-upload-file>
        </div>
        <div class="col-lg-8 col-12">
            <div class="row g-3">
                <div class="col-md-10 col-12">
                    <div class="row g-3 p-3" [formGroup]="formUpdateSystem">
                        <div class="box-item">
                            <div class="col-12 mb-3"> <label><b>System name</b></label>
                                <input type="text" class="form-control" placeholder="System Name"
                                    formControlName="System_name">
                            </div>
                            <div class="col-12 mb-3">
                                <label><b>System url</b></label>
                                <input type="text" class="form-control" placeholder="System Url"
                                    formControlName="System_url">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-12">
                    <button class="btn btn-primary sm w-100 h-100" (click)="UpdateSystem()">Update</button>
                </div>

            </div>
        </div>
    </div>
    <br>
    <div class="row p-0 m-0">
        <div class="col-12  box-sort">
            <button *ngFor="let cl of classItems" class="btn"
                [ngClass]="{'btn-sec':sortAction == cl.Class && categoryAction == cl.Category}" (click)="useSort(cl)">
                <span *ngIf="cl.Category != 'O'"> {{cl.Class}}</span>
                <span *ngIf="cl.Category == 'D'"> Day</span>
                <span *ngIf="cl.Category == 'M'"> Month</span>
                <span *ngIf="cl.Category == 'Y'"> Year</span>
                <span *ngIf="cl.Category == 'O'"> On Premise</span>
            </button>
        </div>
    </div>
    <div class="row p-0 m-0">
        <ng-container *ngFor="let pk of packageItem">
            <div class="col-xl-4 col-lg-4 col-md-6 col-12 text-center" *ngIf="pk.Package_category != 'O'">
                <div class="shadow  p-3 mt-5 box-package">
                    <h2>{{pk?.Package_name}}</h2>
                    <hr>
                    <h5>{{pk?.Package_price | number : '1.2-2'}} THB</h5>
                    <p>{{pk?.Package_license}} License </p>
                    <p>Each license is valid for {{pk.Package_type}} month.</p>
                    <h5>Feature</h5>
                    <p *ngFor="let fu of pk.FeatureList">{{fu.text}}</p>
                    <button class="btn btn-primary me-2 w-100 mb-3" (click)="ViewPlan(pk)">Update Plan</button>
                    <button class="btn btn-cancel w-100" (click)="DeletePlan(pk)">Delete Plan</button>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-12 text-center" *ngIf="pk.Package_category == 'O'">
                <div class="shadow  p-3 mt-5 box-package">
                    <h2>Call</h2>
                    <hr>
                    <h5>Feature</h5>
                    <p *ngFor="let fu of pk.FeatureList">{{fu.text}}</p>
                    <button class="btn btn-primary me-2 w-100 mb-3" (click)="ViewPlan(pk)">Update Plan</button>
                    <button class="btn btn-cancel w-100" (click)="DeletePlan(pk)">Delete Plan</button>
                </div>
            </div>
        </ng-container>
    </div>
    <br><br><br>

    <p-dialog [header]="headerText" *ngIf="statusPlan" [(visible)]="statusPlan" [breakpoints]="{ '960px': '90vw' }"
        [style]="{ width: '50vw' }">
        <div class="row g-3" [formGroup]="formPlan">
            <div class="col-12">
                <p>Category</p>
                <div class="d-flex">
                    <span class="me-3 pointer" (click)="category('D')"><input type="radio" name="category"
                            [checked]="formPlan.value['Package_category'] == 'D'"> Day</span>
                    <span class="me-3 pointer" (click)="category('M')"> <input type="radio" name="category"
                            [checked]="formPlan.value['Package_category'] == 'M'"> Month</span>
                    <span class="me-3 pointer" (click)="category('Y')"><input type="radio" name="category"
                            [checked]="formPlan.value['Package_category'] == 'Y'"> Year</span>
                    <span class="me-3 pointer" (click)="category('O')"><input type="radio" name="category"
                            [checked]="formPlan.value['Package_category'] == 'O'"> On Premise</span>
                </div>
            </div>
            <ng-container *ngIf="formPlan.value['Package_category'] != 'O'">
                <div class="col-12">
                    <div class="d-flex">
                        <span class="me-3 pointer" (click)="freeTrial()"><input type="radio" name="free"
                                [checked]="formPlan.value['Package_status'] == 2"> Free Trial</span>
                    </div>
                </div>
                <div class="col-12">
                    <div class="d-flex">
                        <span class="me-3 pointer" (click)="promotion()"><input type="radio" name="promotion"
                                [checked]="formPlan.value['Package_promotion'] == 1"> Promotion</span>
                    </div>
                </div>
                <div class="col-6">
                    <p>How many
                        <span *ngIf="formPlan.value['Package_category'] == 'D'">days</span>
                        <span *ngIf="formPlan.value['Package_category'] == 'M'">months</span>
                        <span *ngIf="formPlan.value['Package_category'] == 'Y'">years</span>
                        can it be used?
                    </p>
                    <input type="number" class="form-control" formControlName="Package_sort">
                </div>
                <div class="col-6">
                    <p>Package Name</p>
                    <input type="text" class="form-control" formControlName="Package_name">
                </div>
                <div class="col-6">
                    <p>How many licenses did you get?</p>
                    <input type="number" class="form-control" formControlName="Package_license">
                </div>
                <div class="col-6">
                    <p>Package Price</p>
                    <input type="number" class="form-control" formControlName="Package_price">
                </div>
                <div class="col-6">
                    <p>Package Discount</p>
                    <input type="number" class="form-control" formControlName="Package_discount">
                </div>
            </ng-container>
        </div>

        <br>
        <div class="row g-3">
            <div class="col-12">
                <p>Feature</p>
            </div>
            <div class="col-4" *ngFor="let fu of featureItems">
                <div class="input-icon-end">
                    <input type="text" [(ngModel)]="fu.id" class="form-control mb-1" placeholder="ID">
                    <input type="text" [(ngModel)]="fu.text" class="form-control" placeholder="Feature">
                    <span class="material-symbols-outlined text-danger revmoeFeature" (click)="revmoeFeature(fu)">
                        close
                    </span>
                </div>

            </div>
            <div class="col-12">
                <span class="addFeature" (click)="addFeature()">Add Feature</span>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-12">
                <button *ngIf="createPlan" class="btn btn-primary lg icon-start" (click)="CreatePlan()">
                    <span class="material-symbols-outlined">
                        add
                    </span>
                    Create Plan
                </button>
                <button *ngIf="updatePlan" class="btn btn-primary lg icon-start" (click)="UpdatePlan()">
                    <span class="material-symbols-outlined">
                        edit_square
                    </span>
                    Update Plan
                </button>
            </div>
        </div>
    </p-dialog>
</div>